<template>
    <div class="search-overlay" id="search-overlay">
        <div class="search-overlay__inner">
            <div class="search-overlay__header">
                <div class="container-fluid">
                    <div class="row align-items-center text-center">
                        <div class="col-md-9 col-9">
                            <div class="logo">
<!--                                <a href="index.html">-->
                                    <img src="../assets/img/pied-pro/pied-pro-logo-clean.png" class="img-fluid" alt="site logo">
<!--                                </a>-->
                            </div>
                        </div>
                        <div class="col-md-3 col-3">
                            <div class="search-content text-right">
                                <span class="mobile-navigation-close-icon" @click="toggleClass('removeClass', 'active')"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="search-overlay__body">
<!--                <div class="search-overlay__form">-->
                  <calendar-dentiste></calendar-dentiste>

<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import CalendarDentiste from "@/components/pied-pro-custom/CalendarDentiste";

    export default{
        components: {
          CalendarDentiste
        },
        methods: {
            // offcanvas searchbox
            toggleClass(addRemoveClass, className) {
                const el = document.querySelector('#search-overlay');
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            }
        }
    };
</script>

<style lang="scss">

</style>